import React from 'react';
import { NutritionSettingsPage } from '@front-activerse/modules';
import { useAllSettings } from '../context/AllSettingsContext';
import nutritionDescendantRoutes from '../../NutritionSettings/descendantRoutes';

const NutritionSettingsWrapper: React.FC = () => {
  const { setCurrentModule } = useAllSettings();

  // Set current module when this component mounts
  React.useEffect(() => {
    setCurrentModule('nutrition-settings');
  }, [setCurrentModule]);

  return <NutritionSettingsPage descendantRoutes={nutritionDescendantRoutes} />;
};

export default NutritionSettingsWrapper;
